interface Props {
  href: string;
  title?: string;
}

// External help link rendered as a btn-link with the standard question-circle icon.
export function HelpLink({ href, title = 'Get Help' }: Props) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      title={title}
      className="btn btn-link"
      style={{ paddingLeft: 0, paddingRight: 0 }}
    >
      <i className="far fa-question-circle fa-lg" aria-hidden="true" />
    </a>
  );
}
